import React from "react";
import { testimonials } from "../mock";
import { useReveal } from "../hooks/useReveal";

function Card({ t, index }) {
  const { ref, visible } = useReveal();
  return (
    <figure
      ref={ref}
      style={{ transitionDelay: `${index * 100}ms` }}
      className={`flex flex-col rounded-lg border border-[var(--line)] bg-[#FAFAF7] p-8 reveal ${
        visible ? "is-visible" : ""
      }`}
    >
      <span className="font-serif-display text-5xl text-[var(--accent)] leading-none mb-4">
        &ldquo;
      </span>
      <blockquote className="font-serif-display text-xl md:text-[1.35rem] font-light leading-snug flex-1">
        {t.quote}
      </blockquote>
      <figcaption className="mt-8 pt-6 border-t border-[var(--line)]">
        <p className="font-medium text-[15px]">{t.name}</p>
        <p className="text-[13px] text-[var(--muted)]">{t.title}</p>
      </figcaption>
    </figure>
  );
}

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 bg-[var(--bg-alt)]">
      <div className="container-wide">
        <div className="max-w-2xl mb-14">
          <span className="section-label">Kind words</span>
          <h2 className="font-serif-display font-light text-5xl md:text-6xl mt-4 tracking-[0.015em]">
            Testimonials
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <Card key={t.name} t={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
